import { css as _css } from "@emotion/core";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { withMedia } from 'react-media-query-hoc';
import { ChevronDownIconSmall, ChevronUpIconSmall, PdfIcon } from '@domain-group/fe-co-icon';
import { Heading } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './allhomes-listing-soi.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesListingSoi extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggleSection", () => {
      this.setState(prevState => ({
        isCollapsed: !prevState.isCollapsed
      }));
    });
    this.state = {
      isCollapsed: true
    };
  }
  informationAvailable() {
    return !isEmpty(this.props.suburb);
  }
  renderToggle() {
    return ___EmotionJSX("button", {
      css: styles.toggle,
      type: "button",
      onClick: this.toggleSection
    }, "View ", this.state.isCollapsed ? 'more' : 'less', ___EmotionJSX("span", {
      css: styles.toggleIcon
    }, this.state.isCollapsed ? ___EmotionJSX(ChevronDownIconSmall, null) : ___EmotionJSX(ChevronUpIconSmall, null)));
  }
  renderPdf() {
    return ___EmotionJSX("div", {
      css: styles.pdfContainer
    }, ___EmotionJSX("a", {
      css: styles.pdfLink,
      href: this.props.documentUrl,
      rel: "nofollow"
    }, ___EmotionJSX("span", {
      css: styles.pdfLinkIcon
    }, ___EmotionJSX(PdfIcon, {
      theme: "allhomes",
      size: "regular"
    })), ___EmotionJSX("span", {
      css: styles.pdfLinkText
    }, "Download Statement of Information")), ___EmotionJSX("div", {
      css: /*#__PURE__*/_css([styles.footer, styles.grey])
    }, this.props.disclaimerText));
  }
  renderContact() {
    return ___EmotionJSX("span", null, ___EmotionJSX("div", {
      css: styles.noSoiLabel
    }, "No statement of information is provided by the agent"), ___EmotionJSX("div", {
      css: styles.linkContainer
    }, "Please", ___EmotionJSX("button", {
      css: styles.noSoiLink,
      type: "button",
      onClick: this.props.onContactAgent
    }, "contact agent"), "for details."));
  }
  renderAlternative() {
    return isEmpty(this.props.documentUrl) ? this.renderContact() : this.renderPdf();
  }
  renderPriceLabel() {
    if (this.props.sellingPriceFrom && this.props.sellingPriceTo) {
      return 'RANGE BETWEEN';
    }
    if (this.props.sellingPriceFrom || this.props.sellingPriceTo) {
      return 'PRICE';
    }
    return '';
  }
  render() {
    var _this$props$media = this.props.media,
      mobile = _this$props$media.mobile,
      tablet = _this$props$media.tablet,
      desktop = _this$props$media.desktop;
    return ___EmotionJSX("section", {
      css: styles.soi
    }, ___EmotionJSX(Heading, {
      css: styles.heading,
      title: "Statement of information",
      subtitle: "Section 47AF of the Estate Agents Act 1980"
    }), this.informationAvailable() ? ___EmotionJSX("div", {
      css: this.state.isCollapsed && styles.contentCollapsed
    }, ___EmotionJSX("div", {
      css: styles.leftSection
    }, ___EmotionJSX("div", {
      css: styles.sellingPrice
    }, ___EmotionJSX("div", {
      css: styles.headingText
    }, "Indicative selling price*"), ___EmotionJSX("div", {
      css: styles.heavy
    }, this.renderPriceLabel()), ___EmotionJSX("div", {
      css: styles.value
    }, this.props.sellingPriceFrom && this.props.sellingPriceTo ? "".concat(this.props.sellingPriceFrom, " - ").concat(this.props.sellingPriceTo) : this.props.sellingPriceFrom || 'Not provided'), ___EmotionJSX("div", {
      css: styles.ref
    }, "* For the meaning of this price see consumer.vic.gov.au/underquoting")), ___EmotionJSX("span", {
      css: styles.shortSeparator
    }, "\xA0"), ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: styles.headingText
    }, "Median ", this.props.propertyType.toLowerCase(), " price*"), ___EmotionJSX("div", {
      css: styles.unitPriceContents
    }, "for", ___EmotionJSX("div", {
      css: styles.text
    }, "\xA0", this.props.suburb), isEmpty(this.props.period) ? '' : ___EmotionJSX("span", null, ' ', "for period", ___EmotionJSX("div", {
      css: styles.text
    }, "\xA0", this.props.period))), this.props.medianPrice ? ___EmotionJSX("div", {
      css: styles.heavy
    }, "PRICE") : '', ___EmotionJSX("div", {
      css: styles.value
    }, this.props.medianPrice || 'Not provided'), ___EmotionJSX("div", {
      css: /*#__PURE__*/_css([styles.grey, styles.heavy])
    }, "* Sourced from ", this.props.source, "."))), tablet || mobile ? ___EmotionJSX("span", {
      css: styles.shortSeparator
    }, "\xA0") : '', ___EmotionJSX("div", {
      css: styles.comparableSales
    }, ___EmotionJSX("div", {
      css: styles.headingText
    }, "Comparable sales"), ___EmotionJSX("div", {
      css: styles.comparableSalesDescription
    }, this.props.comparableSales && !isEmpty(this.props.declarationText) ? this.props.declarationText : '', desktop || tablet ? ___EmotionJSX("table", {
      css: styles.comparableSalesTable
    }, ___EmotionJSX("thead", null, ___EmotionJSX("tr", null, ___EmotionJSX("th", null, "Address"), ___EmotionJSX("th", null, "Price"), ___EmotionJSX("th", null, "Sold Date"))), ___EmotionJSX("tbody", null, this.props.comparableSales.map(item => ___EmotionJSX("tr", {
      key: "".concat(item.addressLine1).concat(item.addressLine2),
      css: styles.comparableSalesMobileTableRow
    }, ___EmotionJSX("td", {
      css: styles.comparableSalesTableData
    }, ___EmotionJSX("div", null, item.addressLine1), ___EmotionJSX("div", null, item.addressLine2)), ___EmotionJSX("td", {
      css: styles.comparableSalesTableData
    }, item.price), ___EmotionJSX("td", {
      css: styles.comparableSalesTableData
    }, item.soldDate))))) : '', mobile ? ___EmotionJSX("div", null, this.props.comparableSales.map(item => ___EmotionJSX("div", {
      key: "".concat(item.addressLine1).concat(item.addressLine2),
      css: styles.comparableSalesMobileTableRow
    }, ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: styles.comparableSalesMobileTableRowItemLabel
    }, "Address"), ___EmotionJSX("div", {
      css: styles.comparableSalesMobileTableRowItemValue
    }, ___EmotionJSX("div", null, item.addressLine1), ___EmotionJSX("div", null, item.addressLine2))), ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: styles.comparableSalesMobileTableRowItemLabel
    }, "Price"), ___EmotionJSX("div", {
      css: styles.comparableSalesMobileTableRowItemValue
    }, item.price)), ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: styles.comparableSalesMobileTableRowItemLabel
    }, "Sold Date"), ___EmotionJSX("div", {
      css: styles.comparableSalesMobileTableRowItemValue
    }, item.soldDate))))) : '', isEmpty(this.props.comparableSales) && (desktop || tablet) ? ___EmotionJSX("span", {
      css: styles.comparableSalesMobileEmptyTable
    }, "Not provided") : '')), ___EmotionJSX("div", {
      css: /*#__PURE__*/_css([styles.footer, styles.grey])
    }, this.props.disclaimerText)) : this.renderAlternative(), mobile && this.informationAvailable() ? this.renderToggle() : '');
  }
}
AllhomesListingSoi.propTypes = {
  media: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  documentUrl: PropTypes.string,
  declarationText: PropTypes.string,
  sellingPriceFrom: PropTypes.string,
  sellingPriceTo: PropTypes.string,
  suburb: PropTypes.string,
  period: PropTypes.string,
  source: PropTypes.string,
  propertyType: PropTypes.string,
  medianPrice: PropTypes.string,
  comparableSales: PropTypes.arrayOf(PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    price: PropTypes.string,
    soldDate: PropTypes.string
  })),
  disclaimerText: PropTypes.string,
  onContactAgent: PropTypes.func
};
AllhomesListingSoi.defaultProps = {
  documentUrl: null,
  declarationText: null,
  sellingPriceFrom: null,
  sellingPriceTo: null,
  medianPrice: null,
  comparableSales: [],
  period: null,
  suburb: null,
  source: 'Unknown',
  propertyType: 'House',
  disclaimerText: 'Indicative selling price, median house price for the suburb and comparable sales information ' + 'has been provided by the agent in compliance with Estate Agents Act 1980.',
  onContactAgent: () => {}
};
export default withMedia(AllhomesListingSoi);
export { AllhomesListingSoi as BaseAllhomesListingSoi };